import { PrescricaoType, Receituario, TarjaType, TipoReceitaSncr } from '_metronic/helpers/enums'

/** O que basta de um medicamento (do catálogo ou digitado agora) para saber se ele é controlado. */
export type MedicamentoComTarja = {
  controleEspecial?: boolean
  tarja?: string
  receituario?: Receituario
} | null

/**
 * Medicamento de controle especial (Portaria 344): o backend decide pelo `Medicamento`
 * (`isControleEspecial`); aqui é só a leitura do item escolhido no formulário, antes de salvar.
 * Com `receituario` presente ele manda; a tarja fica como fallback de item carregado sem o campo.
 */
export const isControleEspecial = (item?: MedicamentoComTarja): boolean => {
  if (!item) return false
  if (item.receituario) {
    return item.receituario !== Receituario.Simples && item.receituario !== Receituario.RET
  }
  return (
    !!item.controleEspecial ||
    item.tarja === TarjaType.Preta ||
    item.tarja === TarjaType.VermelhaSobRestricao
  )
}

const TIPO_SNCR_DO_RECEITUARIO: Partial<Record<Receituario, TipoReceitaSncr>> = {
  [Receituario.RCE]: TipoReceitaSncr.RCE,
  [Receituario.RET]: TipoReceitaSncr.RET,
  [Receituario.NRA]: TipoReceitaSncr.NRA,
  [Receituario.NRB]: TipoReceitaSncr.NRB,
  [Receituario.NRB2]: TipoReceitaSncr.NRB2,
  [Receituario.NRR]: TipoReceitaSncr.NRR,
}

/**
 * Tipo de numeração SNCR ligado ao item, para o aviso de saldo enquanto a receita é montada,
 * espelhando `Prescricao.getTipoReceitaSncrExigido` do backend: RCE, RET ou o tipo da notificação
 * (cada medicamento de notificação vira um documento próprio). Depois de salva, quem manda é
 * `tipoReceitaSncrExigido` da view; se bloqueia a assinatura, decide a flag de cada família.
 */
export const tipoReceitaSncrDoItem = (
  category: PrescricaoType | undefined,
  item?: MedicamentoComTarja
): TipoReceitaSncr | undefined => {
  if (category !== PrescricaoType.Medicamento && category !== PrescricaoType.Especial) {
    return undefined
  }
  if (item?.receituario) {
    return TIPO_SNCR_DO_RECEITUARIO[item.receituario]
  }
  if (isControleEspecial(item)) return TipoReceitaSncr.RCE
  if (item?.tarja === TarjaType.Vermelha) return TipoReceitaSncr.RET
  return undefined
}
